import { useModal } from '@shared/model/useModal';

export const useTimezoneModal = () => useModal('timezone')